import React from 'react';
import { LayoutProps, SpaceProps, space, layout } from 'styled-system';
import styled from 'styled-components';
import Button from '@ingka/button';

//This is component used to skip content in the planner

const StyledSkapaButton = styled(Button)`
  clip: rect(0 0 0 0);
  clip-path: inset(100%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  z-index: 2000;
  background: rgb(var(--colour-static-light-grey, 245, 245, 245));
  &:focus-visible {
    overflow: initial;
    clip: auto;
    height: auto;
    width: auto;
    clip-path: initial;
  }
`;

const Box = styled.div<LayoutProps & SpaceProps>`
  ${layout}
  ${space}
`;

type ExtendProps = React.CSSProperties &
  SpaceProps &
  LayoutProps &
  React.HTMLAttributes<HTMLDivElement>;

export interface ButtonProps extends ExtendProps {
  skipToId: string;
  text: string;
  dataTestId?: string;
}

const SkipButton = ({ skipToId, text, dataTestId, ...props }: ButtonProps) => {
  const handleSkipButton = () => {
    const elementToFocus = document.getElementById(skipToId);

    if (elementToFocus !== null) {
      const buttons = elementToFocus.querySelectorAll('button:not([disabled])');
      if (buttons[0] !== undefined) {
        elementToFocus.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
        (buttons[0] as HTMLElement).focus();
      } else {
        elementToFocus.focus();
      }
    }
  };

  return (
    <Box {...props}>
      <StyledSkapaButton
        data-testid={dataTestId}
        type="secondary"
        onClick={() => handleSkipButton()}
        text={text}
        size={'small'}
      />
    </Box>
  );
};

export default SkipButton;
